import { gql } from "@apollo/client";

export const WHATSAPP_TEMPLATE_CREATE_MUTATION = gql`
  mutation WhatsAppTemplateCreate($input: WhatsAppTemplateInput!) {
    whatsappTemplateCreate(input: $input) {
      template {
        id
        name
        displayName
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_TEMPLATE_UPDATE_MUTATION = gql`
  mutation WhatsAppTemplateUpdate($id: ID!, $input: WhatsAppTemplateInput!) {
    whatsappTemplateUpdate(id: $id, input: $input) {
      template {
        id
        name
        displayName
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_TEMPLATE_DELETE_MUTATION = gql`
  mutation WhatsAppTemplateDelete($id: ID!) {
    whatsappTemplateDelete(id: $id) {
      template {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_CAMPAIGN_CREATE_MUTATION = gql`
  mutation WhatsAppCampaignCreate($input: WhatsAppCampaignCreateInput!) {
    whatsappCampaignCreate(input: $input) {
      campaign {
        id
        name
        status
        totalRecipients
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_CAMPAIGN_SEND_MUTATION = gql`
  mutation WhatsAppCampaignSend($id: ID!) {
    whatsappCampaignSend(id: $id) {
      campaign {
        id
        status
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_CAMPAIGN_DUPLICATE_MUTATION = gql`
  mutation WhatsAppCampaignDuplicate($id: ID!, $name: String) {
    whatsappCampaignDuplicate(id: $id, name: $name) {
      campaign {
        id
        name
        status
        totalRecipients
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_CAMPAIGN_DELETE_MUTATION = gql`
  mutation WhatsAppCampaignDelete($id: ID!) {
    whatsappCampaignDelete(id: $id) {
      campaign {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_MEDIA_UPLOAD_MUTATION = gql`
  mutation WhatsAppMediaUpload($file: Upload!, $mediaType: WhatsAppMediaType) {
    whatsappMediaUpload(file: $file, mediaType: $mediaType) {
      media {
        id
        fileName
        fileUrl
        fileSize
        mediaType
        createdAt
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_MEDIA_DELETE_MUTATION = gql`
  mutation WhatsAppMediaDelete($id: ID!) {
    whatsappMediaDelete(id: $id) {
      media {
        id
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const WHATSAPP_TEMPLATES_SYNC_MUTATION = gql`
  mutation WhatsAppTemplatesSync {
    whatsappTemplatesSync {
      syncedCount
      templates {
        id
        name
        displayName
        category
        languageCode
        status
        parameterSchema
        isActive
      }
      errors {
        field
        message
        code
      }
    }
  }
`;


